<div class="generalPage pb-4rem">
  <div class="mx-2">
    <div class="flex-display">
      <div class="font-32 content-blue ml-2 fw-500" role="heading" aria-level="2">{{proposedASUs_header}}</div>
      <div><img src="../../../../assets/icons/Help.svg" (click)="Openlink($event)" id="/relatedproposedasus" class="learnmore-image2 mtl-8px" alt="Archive"></div>
    </div>
    <div class="answer font-16 content-blue width-80 ml-2 ">{{proposedASUs_description}}</div>

    <article class="answer font-16 content-blue width-auto mx-2" [innerHTML]="content"></article>
    <div *ngFor="let section of source" class="subHeading mx-2">
        <div *ngIf="section.source?.expireDate == null || this.currentdate < section.source?.expireDate">
          <article class="answer font-24 content-blue width-auto mb-2 bold">{{section.source?.title}}</article>
          <div class="ml-2">
            <div><span class="fw-500 mr-5 lineheight-2rem">{{proposedASUs_issued}}</span><span>{{section.source?.issuedDate | date:'longDate'}}</span></div>
            <div><span class="fw-500 mr-5 lineheight-2rem">{{proposedASUs_commentdue}}</span><span>{{section.source?.commentsDueDate | date:'longDate'}}</span></div>
            <div class="mb-1"><article class="answer font-16 content-blue width-auto">{{section.source?.body}}</article></div>
          </div>
          <div class="mtb-0-2 ml-2 flex-display">
            <div class="fw-500 pt-0-25 mr-5">{{proposedASUs_forMoreInformation}}</div>&nbsp;
            <div class="flex-display">
              <div><img src="../../../../assets/icons/Help.svg" class="image-info learnmore-image2" alt="Archive"></div>
              <div class="pdf-link mr_0_5rem" (click)="openLinkById($event)" [id]="section.source?.pdfFilename">{{section.source?.pdfName}}</div>
              <div><img src="../../../assets/icons/PDF_icon.svg" alt="PDF" class="pdf-image h-20px image-info"></div>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>
